angular.
module("digiexam.services").
filter("formattimepart", function formattimepart() {
	"use strict";
	return function zeroPad(timepart) {
		if (timepart < 10) {
			return "0" + timepart;
		}
		return String(timepart);
	};
});
